// Smart API URL detection - works on both preview and deployed domain
const getApiUrl = () => {
  // If REACT_APP_BACKEND_URL is set and we're on the same domain, use it
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // In production (deployed domain like studyalliance.ca), use same-origin
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    // If we're NOT on the preview/localhost URL, use current origin
    if (envUrl && currentOrigin !== envUrl && !currentOrigin.includes('localhost')) {
      return currentOrigin + '/api';
    }
  }
  
  return (envUrl || '') + '/api';
};

export const API = getApiUrl();
